import React from 'react';
import cx from 'classnames';

import { BodyBase } from '../../../typography/Paragraphs';
import sealImage from './norton-seal.png';

import styles from './securitySeal.module.less';

export const SecuritySeal = ({ className }: { className?: string }) => (
  <div className={cx(styles.securitySeal, className)}>
    <img src={sealImage} alt="Norton Secured Security Seal" />
    <BodyBase>
      Encrypted with 128-bit SSL.
      <br /> 100% Secure
    </BodyBase>
  </div>
);

export default SecuritySeal;
